// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1FXGU","form":"styles_form__30I-g"};